import { breakpoints, fonts } from 'style'
import styled from 'styled-components'

export const DashboardHelpContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 16px;

  a {
    font-size: 18px;
    line-height: 18px;
    color: #000000;

    h4 {
      font-family: ${fonts.main};
      display: flex;
      align-items: center;
    }
  }

  @media (max-width: ${breakpoints.sm}px) {
    display: none;
  }
`
